import React, { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import { showPrintNotes } from '@mummssoftware/utils/utils';
import { PNCounterContext } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK } from '@mummssoftware/global-context/PNCounter/constants';
import {
  WidgetPrintHeader,
  Container,
  BodyPrint,
} from '@mummssoftware/common-ui';
import { PatientAssistanceContext } from '../../context';
import { PatientAssistanceTable } from '../PatientAssistance/PatientAssistanceTable';
import { PrintNotes } from './PrintNotes';
import defaults from '../../translations/en.json';

// way to get next page break with global printing
const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

type PatientAssistancePrintProps = {
  adminTasks: mumms.PatientCppTask[];
  onWidgetReady?: (arg: mumms.ComponentName) => void;
};

export const PatientAssistancePrint = ({
  adminTasks,
  onWidgetReady,
}: PatientAssistancePrintProps) => {
  // on component did mount
  useEffect(() => {
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('PatientAssistance' as mumms.ComponentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { countValues } = useContext(PNCounterContext);
  const { printConfig, observation, patient, agency } = useContext(
    PatientAssistanceContext,
  );
  const pcpptNotes =
    countValues &&
    patient &&
    countValues[patient.patientNumber][ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK];
  const [taskNotes, setTasknotes] = useState<any>(null);

  const showNotes = showPrintNotes(printConfig);

  useEffect(() => {
    // make API calls when needed => only when printing
    if (showNotes && pcpptNotes && pcpptNotes.length) {
      getNotes();
    }
  }, [JSON.stringify(pcpptNotes)]);

  // todo strategy printing for cross Platform and patientNumber
  const getNotes = async () => {
    const pnNotes =
      observation &&
      (await observation.getWidgetPnNotes(
        patient?.patientNumber as string,
        agency as string,
        ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK,
      ));

    setTasknotes(pnNotes);
  };

  return (
    <Container>
      <BodyPrint id="print-assistance">
        <WidgetPrintHeader title={defaults.title} />
        <PatientAssistanceTable viewModePrint smallWidget={false} />
        <PrintNotes tasks={adminTasks} taskNotes={taskNotes} />
      </BodyPrint>
      <PageBreak />
    </Container>
  );
};

export default PatientAssistancePrint;
